import React from 'react';
import Features from '../HomePages/components/Features';
import ServicesList from './ServicesList';

export default function ServicesPage() {
  return (
    <>
      <section className="text-center py-12 bg-white">
        <h1 className="text-4xl md:text-5xl font-bold text-[var(--color-primary)] mb-4">Hizmetlerimiz</h1>
        <p className="text-lg md:text-xl text-[var(--color-black)] max-w-2xl mx-auto mb-8">
          SolarTools olarak, enerji yönetimi ve dijitalleşme alanında uçtan uca çözümler sunuyoruz. Aşağıda öne çıkan hizmetlerimizi inceleyebilirsiniz.
        </p>
      </section>
      <Features />
      <ServicesList />
    </>
  );
} 